export const localhost = 'localhost'

const getDevHost = () => process.env?.REACT_APP_BACKEND_HOST || localhost

export const generateBaseURL = () => {
  if (process.env?.REACT_APP_ENV_MODE === 'prod') {
    return `/api`
  }
  return `https://${getDevHost()}/api`
}

export const generateBaseURLWebSocket = () => {
  if (process.env?.REACT_APP_ENV_MODE === 'prod') {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
    return `${protocol}://${window.location.host}/ws`
  }
  return `wss://${getDevHost()}/api/`
}

